export enum ForYouDisplayActions {
    APPLY = "apply",
    OPEN = "open",
    CLOSE = "close"
}
export enum ForYouDisplayActions {
    APPLY = "apply",
    OPEN = "open",
    CLOSE = "close"
}
